import { render, staticRenderFns } from "./EditarLead.vue?vue&type=template&id=33991042"
import script from "./EditarLead.vue?vue&type=script&lang=ts"
export * from "./EditarLead.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports